/**
 * @generated SignedSource<<427eec916a559eca88bb321a35ae6182>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary$data = {
  readonly accepted: number;
  readonly rejected: number;
  readonly unanswered: number;
  readonly " $fragmentType": "WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary";
};
export type WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary$key = {
  readonly " $data"?: WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accepted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unanswered",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rejected",
      "storageKey": null
    }
  ],
  "type": "IntegrationTurnpikeSummary",
  "abstractKey": null
};

(node as any).hash = "5cb605f418108830e3abd815fdfbe275";

export default node;
